@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Lead Docket Log Details"
                  cancelHelpContentId="app.cancel"
                  cancelClass="btn-primary"
                  [hideSave]="true"
                  (cancel)="cancel()">
    @if (leadDocketDiagnosticsDetail) {
        <div class="ws-flex-container-vertical ws-stretch">
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label>Request Payload:</label>
                <textarea class="form-control" disabled style="width: 100%" rows="5" [(ngModel)]="leadDocketDiagnosticsDetail.requestPayloadJson"></textarea>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Response Payload:</label>
                <textarea class="form-control" disabled style="width: 100%" rows="5" [(ngModel)]="leadDocketDiagnosticsDetail.responsePayloadJson"></textarea>
            </div>
            <div class="ws-flex-container-vertical ws-flex-auto">
                <label style="margin-top: 16px">Logs:</label>
                <lead-docket-log-details-grid
                    [detailLogs]="leadDocketDiagnosticsDetail.detailLogs">
                </lead-docket-log-details-grid>
            </div>
        </div>
    }
</ws-modal-wrapper>
